import { initTerrain } from "./terrain";
import { wireCursorSignal, wireNavigationMenu, wirePartnerIntakeLinks, wireStaticIcons } from "./ui";

function isE2eMode(): boolean {
  return new URLSearchParams(window.location.search).has("e2e");
}

function mountE2eCanvas(container: HTMLElement): void {
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(window.innerWidth, 1);
  canvas.height = Math.max(window.innerHeight, 1);
  canvas.style.width = "100%";
  canvas.style.height = "100%";
  container.append(canvas);
}

function boot(): void {
  const canvasContainer = document.getElementById("canvas-container");
  if (canvasContainer instanceof HTMLElement) {
    if (isE2eMode()) {
      mountE2eCanvas(canvasContainer);
    } else {
      const terrain = initTerrain(canvasContainer);
      window.addEventListener("pagehide", () => terrain.destroy(), { once: true });
    }
  }

  wireStaticIcons();
  wireNavigationMenu();
  void wirePartnerIntakeLinks();
  wireCursorSignal();
}

boot();
